import { Box, FormControl, Paper, styled, Typography } from "@mui/material";
import { theme } from "../../../theme";

export const WidgetContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  backgroundColor: theme.palette.background.paper,
  borderRadius: "8px",
  boxShadow: theme.shadows[2],
  padding: "10px",
  height: "500px",
  boxSizing: "border-box",
  minWidth: 0,
}));

export const WidgetTitle = styled(Typography)(({ theme }) => ({
  fontSize: "1.25rem",
  fontWeight: 600,
  color: theme.palette.text.primary,
  textAlign: "center",
  marginBottom: theme.spacing(1),
}));

export const OptionContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "10px",
  padding: "10px 0",
});

export const StyledFormControl = styled(FormControl)({
  minWidth: "80px",
  margin: "0 5px",
  "& .MuiInputBase-root": {
    fontSize: "0.875rem",
    height: "32px",
  },
  "& .MuiFormHelperText-root": {
    fontSize: "0.75rem",
  },
});


export const OptionRow = styled(Box)({
  display: "flex",
  justifyContent: "center",
  width: "100%",
  alignItems: "flex-start"
});

export const ActionRow = styled(Box)({
  display: "flex",
  justifyContent: "center",
  gap: "10px",
  width: "100%",
});

export const NoDataText = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: 'normal',
  color: theme.palette.text.primary,
}));

export const LargeChartWrapper = styled(Box)({
  position: "relative",
  width: "100%",
  paddingTop: "25em",
  "& > div": {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
  },
});

export const ChartContainer = styled(Box)({
  position: "relative",
  width: "100%",
  height: "100%",
  display: "flex",
  overflow: "hidden",
  justifyContent: "center",
  alignItems: "center",
  boxSizing: "border-box",
  "& > div": {
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden",
  },
});

export const TableWrapper = styled(Paper)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[2],
  display: "grid",
  gridTemplateColumns: "3fr 2fr 2fr 6fr",
  rowGap: theme.spacing(1.5),
  columnGap: theme.spacing(3),
  fontSize: "0.95rem",
}));

export const TableColumnHeaderWrapper = styled(Box)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.text.primary,
  borderBottom: `2px solid ${theme.palette.divider}`,
  paddingBottom: theme.spacing(1),
  display: "flex",
  alignItems: "center",
}));

export const BasicTableRowStyles = styled(Box)(({ theme }) => ({
  display: "contents",
}));

export const CellBox = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  display: "flex",
  color: theme.palette.text.secondary,
  overflow: "hidden",
  textOverflow: "ellipsis",
  alignItems: "flex-start",
  whiteSpace: "normal",
  overflowWrap: "anywhere",
}));

export const BorderRow = styled("div")(({ theme }) => ({
  gridColumn: "1 / -1",
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const RowWrapper = styled(Box)(({ theme }) => ({
  display: "contents",
  "&:nth-of-type(even) > div": {
    backgroundColor: theme.palette.action.hover,
  },
}));
